import { Component, OnInit,ComponentFactoryResolver, ChangeDetectorRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AspLearnWithAutoverseService } from './asp-learn-with-autoverse.service';
// import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
// import { AspLoadingService } from "../asp-loading/asp-loading.service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ElementRef } from '@angular/core';




@Component({
  selector: 'app-asp-learn-with-autoverse',
  templateUrl: './asp-learn-with-autoverse.component.html',
  styleUrls: ['./asp-learn-with-autoverse.component.scss']
})
export class AspLearnWithAutoverseComponent implements OnInit {
  emptyList:any = 'assets/images/no-cart.png';
  // @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;
  showLanguagePopup = true;
  selectedLanguage = 'english';
  tabs: string[] = [];
  selectedTab: string = '';
  allVideos: any[] = [];
  dummyVideos: any[] = [];
  backgroundImage: string = '';
  activeVideoUrl: SafeResourceUrl | null = null;
isYouTubeVideo: boolean = false;

  @ViewChild('videoContainer') videoContainerRef!: ElementRef;

  searchControl: FormControl = new FormControl('');

  constructor(
    private router: Router,
    private videoService: AspLearnWithAutoverseService,
     private resolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
      private sanitizer: DomSanitizer
    // private aspLoadingService: AspLoadingService,

  ) {}

  ngOnInit(): void {
    this.showLanguagePopup = true;

    this.searchControl.valueChanges.subscribe(value => {
      this.applySearch(value);
    });
  }
  //   loadingMsg() {
    
  //   const factory = this.resolver.resolveComponentFactory(AspLoadingComponent);
    
   

  //   if (this.containers) {
  //     const componentRef = this.containers.createComponent(factory);
      

  //     const componentBInstance = componentRef.instance as AspLoadingComponent;
  //     componentBInstance.getLoadingMsg();
  //   } else {
  //     console.error('containers is undefined');
  //   }
  // }
  // ngAfterViewInit() {
  //   this.loadingMsg();
  //   this.cdr.detectChanges();
  // }

  chooseLanguage(lang: string): void {
    this.loadVideos(lang);
    this.selectedLanguage = lang;
    this.showLanguagePopup = false;
    
  }

  closePopup(): void {
    this.selectedLanguage = 'english';
    this.showLanguagePopup = false;
    this.loadVideos('english');
  }

loadVideos(lang: string): void {
  const garageKey = localStorage.getItem('garageKey') || '';

  if (!garageKey) {
    console.warn('GarageKey not found in local storage');
    return;
  }

  this.videoService.getVideos(lang, garageKey).subscribe({
    next: (res: any) => {
      // ✅ Get and assign video links
      this.allVideos = Array.isArray(res?.data?.videoLinks) ? res.data.videoLinks : [];

      // ✅ Get and assign background image
      // this.backgroundImage = res?.data?.backgroundImage || '';
      this.backgroundImage = Array.isArray(res?.data?.backgroundImage) ? res.data.backgroundImage[0] : '';


      // ✅ Extract categories
      const allCategories: string[] = this.allVideos.reduce((acc: string[], video) => {
        const rawCategories = video.categories || '';
        const splitCats = rawCategories.split(/[,|]/).map(cat => cat.trim());
        return acc.concat(splitCats);
      }, []);

      const categorySet = new Set<string>(allCategories);
      this.tabs = ['All', ...Array.from(categorySet)];
      this.selectedTab = this.tabs[0] || '';
      this.filterVideosByTab();
    },
    error: (err) => {
      console.error('Error fetching videos:', err);
      this.allVideos = [];
      this.dummyVideos = [];
      this.tabs = [];
      this.selectedTab = '';
      this.backgroundImage = ''; // Reset background if error
    }
  });
}

applySearch(value: string): void {
  const term = value?.toLowerCase().trim();
  const category = this.selectedTab;

  this.dummyVideos = this.allVideos.filter(video => {
    const matchesSearch =
      !term || video.videoTitles?.toLowerCase().includes(term);

    const categories = (video.categories || '').split(/[,|]/).map(cat => cat.trim());
    const matchesCategory =
      category === 'All' || categories.includes(category);

    return matchesSearch && matchesCategory;
  });
}


clearSearch(): void {
  this.searchControl.setValue('');
  this.applySearch('');
}

selectTab(tab: string): void {
  this.selectedTab = tab;
  this.applySearch(this.searchControl.value);
  this.filterVideosByTab();
}
filterVideosByTab(): void {
  if (this.selectedTab.trim().toLowerCase() === 'all') {
    this.dummyVideos = this.allVideos;
  } else {
    this.dummyVideos = this.allVideos.filter(video => {
      const categories = (video.categories || '')
        .split(/[,|]/)
        .map(cat => cat.trim().toLowerCase());

      return categories.includes(this.selectedTab.trim().toLowerCase());
    });
  }

  // console.log('Selected tab:', this.selectedTab);
  // console.log('Filtered videos:', this.dummyVideos);
}
 openVideoPopup(video: any): void {
    const videoUrl = video?.videoLinks;

    if (!videoUrl) return;

    const videoId = this.extractYouTubeId(videoUrl);
    if (videoId) {
      this.isYouTubeVideo = true;
      this.activeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&showinfo=0&controls=1`
      );
    } else {
      this.isYouTubeVideo = false;
      this.activeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
    }

    // Wait for DOM update before requesting fullscreen
    setTimeout(() => this.enterFullscreen(), 100);
  }

  enterFullscreen(): void {
    const elem = this.videoContainerRef?.nativeElement;
    if (elem?.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem?.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem?.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  }

closeVideoPopup(): void {
  this.activeVideoUrl = null;
  this.isYouTubeVideo = false;
}

extractYouTubeId(url: string): string | null {
  const regExp =
    /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/;
  const match = url.match(regExp);
  return match && match[1] ? match[1] : null;
}
playVideo(videoId: string) {
  const baseUrl = `https://www.youtube.com/embed/${videoId}?controls=0&modestbranding=1&rel=0&showinfo=0&autoplay=1`;
  this.activeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(baseUrl);
}
}
